/**
 * Reads JWT `exp` (seconds since epoch) without verifying the signature — only for client-side lifetime hints.
 */
export function getAccessTokenExpiryMsFromJwt(accessToken: string): number | null {
  try {
    const parts = accessToken.split(".");
    if (parts.length !== 3) {
      return null;
    }
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json: unknown = JSON.parse(atob(padded));
    if (!json || typeof json !== "object" || !("exp" in json)) {
      return null;
    }
    const exp = (json as { exp?: unknown }).exp;
    if (typeof exp !== "number" || !Number.isFinite(exp)) {
      return null;
    }
    return exp * 1000;
  } catch {
    return null;
  }
}
